<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.questions', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="md:grid md:grid-cols-2 md:gap-6">
            <div class="mt-3 p-2">
                <QuestionLineGraph :data="questionLineGraph"
                 :value="questionLineGraph.p0"
                />
            </div>
            <div class="flex flex-col gap-2">
                <div>
                    <div>
                        <input
                            type="range"
                            name="number"
                            class="w-full"
                            style="max-width: 500px"
                            v-model.number="questionLineGraph.p0"
                            :min="questionLineGraph.domainX[0]"
                            :max="questionLineGraph.domainX[1]"
                            :step="questionLineGraph.step"
                        >
                    </div>
                </div>
                <div class="flex gap-2">
                    <FormLabel value="step"/>
                    <FormInput v-model.number="questionLineGraph.step" type="number" class="w-20"/>
                </div>
                <div>
                    <FormLabel value="domainX"/>
                    <div class="flex gap-2">
                        <FormInput v-model="questionLineGraph.domainX[0]" class="w-20"/>
                        <FormInput v-model="questionLineGraph.domainX[1]" class="w-20"/>
                    </div>
                </div>
                <div class="flex gap-2">
                    <FormLabel value="gridSize"/>
                    <FormInput v-model.number="questionLineGraph.gridSize" type="number" class="w-20"/>
                </div>
                <div class="flex gap-2">
                    <FormLabel value="p0"/>
                    <FormInput v-model.number="questionLineGraph.p0" type="number" class="w-20"/>
                    <button type="button" :title="$t('messages.remove')" @click="questionLineGraph.p0 = null" class="w-6 h-6">
                        <IconTrash class="text-gray-400 pr-1"/>
                    </button>
                </div>
                <div class="flex gap-2">
                    <FormLabel value="p1"/>
                    <FormInput v-model.number="questionLineGraph.p1" type="number" class="w-20"/>
                    <button type="button" :title="$t('messages.remove')" @click="questionLineGraph.p1 = null" class="w-6 h-6">
                        <IconTrash class="text-gray-400 pr-1"/>
                    </button>
                </div>
                <div class="flex gap-2">
                    <FormLabel value="p2"/>
                    <FormInput v-model.number.trim="questionLineGraph.p2" type="number" class="w-20"/>
                    <button type="button" :title="$t('messages.remove')" @click="questionLineGraph.p2 = null" class="w-6 h-6">
                        <IconTrash class="text-gray-400 pr-1"/>
                    </button>
                </div>
                <div class="flex gap-2">
                    <FormLabel value="p3"/>
                    <FormInput v-model.number="questionLineGraph.p3" type="number" class="w-20"/>
                    <button type="button" :title="$t('messages.remove')" @click="questionLineGraph.p3 = null" class="w-6 h-6">
                        <IconTrash class="text-gray-400 pr-1"/>
                    </button>
                </div>
            </div>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import InertiaPagination from '@/Shared/InertiaPagination.vue';
import InertiaSquareLinkButton from '@/components/InertiaSquareLinkButton.vue';
import QuestionEditFormPanel from '@/components/Quiz/QuestionEditFormPanel.vue';
import HintAlert from '@/components/Quiz/HintAlert.vue';
import BadgePill from '@/components/BadgePill.vue';
import QuestionDescriptionDisplay from '@/components/Quiz/QuestionDescriptionDisplay.vue';
import FormSelect from '@/components/Forms/FormSelect.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormError from '@/components/Forms/FormError.vue';
import EmptyState from '@/components/EmptyState.vue';
import AppButton from '@/components/AppButton.vue';
import { IconCircleXFilled, IconTrash } from '@tabler/icons-vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';
import DataListSuggestions from '@/components/Quiz/DataListSuggestions.vue';
import QuestionBaseDisplay from '@/components/Quiz/QuestionBaseDisplay.vue';
import CopyrightNotice from '@/components/CopyrightNotice.vue';
import SlideOverCheckboxInput from '@/components/Forms/SlideOverCheckboxInput.vue';
import Modal from '@/components/Modal.vue';
import QuestionLineGraph from '@/components/Quiz/QuestionLineGraph.vue';
import FormInput from '@/components/Forms/FormInput.vue';

export default {
    components: {
        IconTrash,
        FormInput,
        QuestionLineGraph,
        Modal,
        SlideOverCheckboxInput,
        CopyrightNotice,
        QuestionBaseDisplay,
        DataListSuggestions,
        SubmitFormButton,
        AppButton,
        EmptyState,
        FormError,
        FormLabel,
        FormSelect,
        QuestionDescriptionDisplay,
        PanelPage,
        InertiaPagination,
        InertiaSquareLinkButton,
        QuestionEditFormPanel,
        HintAlert,
        BadgePill,
        IconCircleXFilled,

    },
    layout: Layout,
    name: 'Index',
    props: ['meta',],
    data() {
        return {
            questionLineGraph: {
                type: 'R1Did',
                domainX: [-2, 4],
                gridSize: 1,
                p0: 1,
                p1: 2,
                p2: 3,
                p3: -4,
                step: 1,
            },
        };
    },
    methods: {},
};
</script>
